import React from 'react';

export default function Banner() {
  return (
    <svg
      width="100%"
      viewBox="0 0 203 131"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMin slice"
    >
      <g clipPath="url(#clip0_7224_4716)">
        <rect width="203" height="131" rx="3" fill="#084D6D" />
        <g filter="url(#filter0_d_7224_4716)">
          <path
            d="M128.352 110.363L89.4549 117.092C84.7206 117.911 81.5476 122.407 82.3679 127.134L89.1075 165.971C89.9279 170.698 94.4308 173.867 99.1651 173.047L138.062 166.318C142.796 165.499 145.969 161.003 145.149 156.276L138.409 117.439C137.589 112.712 133.086 109.544 128.352 110.363Z"
            fill="#E60078"
          />
        </g>
        <path
          d="M127.896 139.643C126.515 131.564 118.783 126.135 110.659 127.525C102.547 128.915 97.0764 136.613 98.4792 144.703C99.8712 152.792 107.592 158.21 115.716 156.821C123.829 155.431 129.288 147.732 127.896 139.643Z"
          fill="#E50278"
        />
        <path
          d="M127.896 139.643C129.288 147.732 123.829 155.431 115.716 156.821C107.592 158.21 99.8712 152.781 98.4792 144.703C97.0872 136.624 102.547 128.915 110.659 127.525C118.783 126.135 126.504 131.564 127.896 139.643ZM124.057 141.771C124.742 141.651 125.21 141.011 125.09 140.327C124.971 139.654 124.318 139.187 123.633 139.306C122.948 139.425 122.48 140.077 122.6 140.75C122.72 141.434 123.372 141.89 124.057 141.771ZM120.023 144.366C120.142 144.996 120.74 145.408 121.371 145.289C122.002 145.17 122.393 144.572 122.274 143.932C122.154 143.324 121.556 142.911 120.947 143.02C120.316 143.128 119.903 143.736 120.023 144.366ZM121.741 140.902C121.643 140.262 121.056 139.838 120.425 139.947C119.794 140.055 119.381 140.642 119.49 141.271C119.598 141.89 120.164 142.303 120.784 142.216C121.415 142.129 121.85 141.532 121.741 140.902ZM119.892 136.874C119.25 136.982 118.837 137.569 118.957 138.209C119.066 138.828 119.642 139.23 120.273 139.132C120.903 139.024 121.317 138.459 121.219 137.84C121.121 137.2 120.545 136.776 119.903 136.885L119.892 136.874ZM115.901 138.709C115.999 139.273 116.543 139.654 117.097 139.556C117.641 139.447 118.011 138.926 117.913 138.383C117.815 137.818 117.282 137.438 116.717 137.536C116.173 137.634 115.803 138.166 115.89 138.709H115.901ZM117.38 135.299C117.282 134.735 116.749 134.355 116.184 134.463C115.64 134.561 115.27 135.082 115.357 135.636C115.455 136.201 115.977 136.57 116.553 136.472C117.108 136.374 117.467 135.864 117.369 135.31L117.38 135.299ZM118.446 141.445C118.348 140.891 117.848 140.533 117.282 140.62C116.706 140.707 116.336 141.239 116.434 141.803C116.532 142.346 117.054 142.726 117.597 142.64C118.163 142.553 118.544 142.021 118.446 141.456V141.445ZM118.359 146.766C117.815 146.853 117.423 147.363 117.5 147.917C117.576 148.492 118.098 148.872 118.663 148.785C119.229 148.699 119.598 148.199 119.522 147.645C119.435 147.07 118.924 146.69 118.359 146.777V146.766ZM118.989 144.54C118.902 143.975 118.402 143.617 117.837 143.693C117.26 143.78 116.88 144.29 116.967 144.866C117.065 145.43 117.587 145.81 118.152 145.702C118.707 145.604 119.066 145.094 118.979 144.54H118.989ZM114.346 141.228C113.824 141.315 113.498 141.782 113.595 142.303C113.682 142.792 114.15 143.128 114.639 143.063C115.14 142.987 115.499 142.498 115.422 141.999C115.346 141.489 114.868 141.152 114.357 141.239L114.346 141.228ZM113.574 136.885C114.085 136.798 114.433 136.331 114.346 135.821C114.259 135.321 113.769 134.974 113.269 135.06C112.78 135.147 112.454 135.614 112.53 136.114C112.606 136.635 113.074 136.971 113.585 136.885H113.574ZM116.477 148.134C116.39 147.624 115.901 147.276 115.401 147.363C114.901 147.45 114.563 147.938 114.65 148.449C114.737 148.948 115.205 149.274 115.694 149.187C116.216 149.1 116.553 148.633 116.466 148.123L116.477 148.134ZM115.944 145.039C115.847 144.529 115.368 144.192 114.857 144.29C114.346 144.388 114.031 144.876 114.128 145.387C114.226 145.875 114.694 146.201 115.194 146.114C115.705 146.027 116.042 145.539 115.944 145.028V145.039ZM113.813 132.737C113.726 132.226 113.237 131.89 112.725 131.988C112.236 132.074 111.91 132.541 111.986 133.041C112.062 133.562 112.541 133.899 113.052 133.812C113.563 133.725 113.9 133.247 113.813 132.737ZM117.021 151.196C116.923 150.686 116.434 150.36 115.923 150.468C115.422 150.566 115.107 151.033 115.205 151.533C115.303 152.043 115.781 152.369 116.303 152.26C116.804 152.162 117.119 151.685 117.032 151.196H117.021ZM114.89 138.883C114.792 138.372 114.313 138.046 113.791 138.155C113.291 138.253 112.976 138.72 113.074 139.219C113.161 139.719 113.628 140.044 114.128 139.958C114.65 139.871 114.988 139.393 114.89 138.883ZM111.801 143.41C112.247 143.334 112.551 142.922 112.475 142.477C112.399 142.053 111.964 141.738 111.529 141.803C111.094 141.879 110.79 142.303 110.866 142.737C110.942 143.182 111.355 143.476 111.801 143.4V143.41ZM112.334 146.483C112.78 146.407 113.084 145.995 113.019 145.56C112.954 145.126 112.53 144.822 112.084 144.898C111.638 144.974 111.344 145.376 111.41 145.821C111.486 146.266 111.888 146.559 112.334 146.483ZM110.333 139.675C110.409 140.12 110.833 140.414 111.268 140.338C111.703 140.262 112.008 139.838 111.942 139.404C111.866 138.969 111.431 138.665 110.996 138.741C110.561 138.817 110.257 139.241 110.333 139.675ZM108.615 139.273C108.245 139.339 107.984 139.697 108.038 140.066C108.104 140.435 108.462 140.696 108.832 140.631C109.235 140.566 109.485 140.207 109.409 139.816C109.332 139.436 108.985 139.197 108.604 139.273H108.615ZM109.952 142.911C109.887 142.531 109.539 142.292 109.158 142.346C108.778 142.412 108.517 142.759 108.571 143.128C108.626 143.508 109.017 143.78 109.398 143.715C109.767 143.649 110.018 143.28 109.952 142.911ZM110.485 146.006C110.431 145.626 110.083 145.365 109.702 145.419C109.322 145.474 109.039 145.854 109.104 146.234C109.169 146.603 109.539 146.853 109.909 146.798C110.279 146.733 110.54 146.386 110.485 146.006ZM107.56 143.324C107.505 143.02 107.168 142.792 106.864 142.868C106.559 142.933 106.364 143.237 106.429 143.541C106.494 143.867 106.788 144.062 107.114 143.997C107.418 143.932 107.625 143.628 107.571 143.334L107.56 143.324ZM107.027 140.272C106.983 139.979 106.69 139.751 106.385 139.784C106.059 139.816 105.831 140.12 105.885 140.446C105.929 140.761 106.211 140.978 106.516 140.935C106.831 140.902 107.07 140.587 107.027 140.272ZM107.614 147.07C107.919 147.015 108.136 146.722 108.093 146.418C108.049 146.103 107.734 145.886 107.408 145.941C107.081 145.995 106.875 146.299 106.951 146.625C107.016 146.939 107.299 147.124 107.614 147.07ZM104.569 143.856C104.656 144.127 104.841 144.279 105.113 144.225C105.385 144.171 105.537 143.953 105.483 143.682C105.428 143.432 105.233 143.291 104.961 143.334C104.667 143.378 104.558 143.573 104.569 143.867V143.856ZM105.472 146.386C105.211 146.483 105.059 146.646 105.113 146.939C105.167 147.211 105.363 147.341 105.624 147.298C105.907 147.254 106.059 147.048 106.016 146.766C105.972 146.483 105.755 146.364 105.472 146.375V146.386ZM104.558 141.152C104.841 141.076 104.993 140.891 104.95 140.62C104.906 140.348 104.689 140.196 104.406 140.251C104.145 140.305 104.004 140.479 104.036 140.75C104.08 141.043 104.276 141.152 104.547 141.152H104.558ZM102.579 140.533C102.449 140.783 102.285 140.946 102.318 141.065C102.351 141.185 102.568 141.358 102.688 141.347C102.797 141.337 102.971 141.109 102.971 140.989C102.971 140.87 102.775 140.75 102.59 140.544L102.579 140.533ZM103.667 144.04C103.416 143.91 103.253 143.747 103.134 143.78C103.003 143.812 102.927 144.019 102.829 144.149C102.96 144.247 103.09 144.42 103.221 144.42C103.34 144.42 103.46 144.236 103.667 144.04ZM104.199 147.102C103.938 146.983 103.775 146.842 103.667 146.874C103.547 146.907 103.471 147.113 103.373 147.244C103.503 147.33 103.645 147.504 103.764 147.493C103.884 147.493 103.993 147.298 104.199 147.102ZM101.372 141.239C101.209 141.174 101.1 141.087 101.024 141.098C100.948 141.119 100.894 141.25 100.828 141.326C100.926 141.391 101.013 141.489 101.111 141.499C101.176 141.499 101.252 141.358 101.361 141.239H101.372ZM101.546 144.073C101.459 144.225 101.361 144.333 101.372 144.399C101.394 144.485 101.513 144.54 101.6 144.616C101.676 144.529 101.785 144.442 101.796 144.333C101.796 144.279 101.666 144.192 101.535 144.073H101.546ZM102.449 147.385C102.264 147.32 102.144 147.233 102.057 147.254C101.992 147.265 101.905 147.428 101.916 147.504C101.938 147.58 102.09 147.689 102.155 147.667C102.242 147.645 102.318 147.526 102.449 147.385Z"
          fill="#0E3880"
        />
        <g filter="url(#filter1_d_7224_4716)">
          <path
            d="M115.864 41.1175L76.3892 47.9469C71.6548 48.766 68.4819 53.262 69.3022 57.9891L76.1421 97.404C76.9624 102.131 81.4653 105.299 86.1996 104.48L125.675 97.6508C130.409 96.8317 133.582 92.3357 132.762 87.6086L125.922 48.1936C125.102 43.4665 120.599 40.2984 115.864 41.1175Z"
            fill="#2164F2"
          />
        </g>
        <path
          d="M99.5341 74.8181C100.491 74.5575 101.448 74.3946 102.329 74.0471C103.21 73.6997 104.015 73.1676 104.874 72.7007C104.896 72.7767 104.928 72.907 104.95 73.0373C105.7 77.3589 106.462 81.6805 107.19 86.013C107.266 86.4908 107.299 86.9903 107.255 87.4681C107.136 88.7928 106.255 89.694 104.928 89.9112C103.623 90.1175 102.503 89.5094 101.981 88.2716C101.829 87.9133 101.72 87.5332 101.644 87.1532C100.937 83.1464 100.252 79.1506 99.5559 75.1438C99.5341 75.0244 99.5341 74.8941 99.5233 74.8289L99.5341 74.8181Z"
          fill="white"
        />
        <path
          d="M101.579 71.2348C99.2296 71.6474 97.022 70.1164 96.5979 67.7927C96.1738 65.4473 97.7398 63.1996 100.089 62.787C102.394 62.3852 104.645 63.9597 105.059 66.2834C105.472 68.6179 103.917 70.8222 101.579 71.2348Z"
          fill="white"
        />
        <path
          d="M88.5613 75.5021C88.5178 75.1112 88.4416 74.7203 88.4416 74.3294C88.3329 69.6168 89.5074 65.2843 92.3458 61.4839C94.1184 59.1168 96.326 57.2926 99.2188 56.4239C102.264 55.5118 105.178 55.7073 107.799 57.6726C108.267 58.0201 108.582 58.563 108.963 59.0191C108.995 59.0625 108.974 59.1385 108.985 59.3448C108.626 59.2362 108.332 59.1711 108.049 59.0625C107.31 58.7802 106.581 58.4219 105.82 58.2047C102.09 57.1406 98.7294 57.9767 95.7279 60.3221C92.5415 62.8086 90.6166 66.1422 89.6705 70.0186C89.279 71.6148 89.0833 73.2652 88.8005 74.894C88.7679 75.1003 88.7353 75.2958 88.7026 75.5021C88.6591 75.5021 88.6156 75.5021 88.5721 75.5021H88.5613Z"
          fill="white"
        />
        <g filter="url(#filter2_d_7224_4716)">
          <path
            d="M172.262 -59.7715L132.476 -52.8883C127.741 -52.0693 124.569 -47.5732 125.389 -42.8461L132.283 -3.12089C133.103 1.6062 137.606 4.77429 142.34 3.95523L182.126 -2.92793C186.86 -3.74699 190.033 -8.24304 189.213 -12.9701L182.319 -52.6953C181.499 -57.4224 176.996 -60.5905 172.262 -59.7715Z"
            fill="#3FAED6"
          />
        </g>
        <g filter="url(#filter3_d_7224_4716)">
          <path
            d="M185.259 9.72183L146.17 16.4845C141.435 17.3035 138.262 21.7996 139.083 26.5267L145.856 65.5565C146.676 70.2836 151.179 73.4517 155.913 72.6326L195.003 65.8699C199.737 65.0509 202.91 60.5548 202.09 55.8277L195.317 16.798C194.496 12.0709 189.993 8.90277 185.259 9.72183Z"
            fill="#213D55"
          />
        </g>
        <path
          d="M149.885 43.709L150.908 43.5352C150.853 43.2095 150.679 42.9163 150.407 42.71C149.961 42.3517 149.309 42.2105 148.428 42.3625C147.547 42.5145 147.08 42.9272 146.906 43.1769C146.732 43.4266 146.492 43.8175 146.732 44.4039C146.862 44.6645 147.09 44.8817 147.362 45.0011C147.819 45.2183 148.385 45.2834 148.602 45.316C148.82 45.3486 149.603 45.3811 149.951 45.5549C150.114 45.6309 150.222 45.772 150.266 45.9458C150.277 46.0652 150.407 46.4018 149.853 46.7167C149.722 46.771 149.004 47.0859 148.33 46.8036C148.167 46.7167 147.982 46.5973 147.884 46.1847L146.862 46.3584C146.916 46.7059 147.101 47.0099 147.384 47.2053C147.873 47.5637 148.667 47.7048 149.559 47.542C150.451 47.3791 151.136 46.9339 151.299 46.315C151.364 45.9892 151.375 45.316 150.69 44.9251C150.396 44.7513 149.951 44.6536 149.668 44.6102C149.385 44.5668 148.308 44.5016 148.026 44.3387C147.743 44.1759 147.732 44.0673 147.689 43.9153C147.645 43.7632 147.699 43.3289 148.232 43.1552C148.765 42.9814 149.7 42.7968 149.896 43.6981L149.885 43.709Z"
          fill="#F08B1F"
        />
        <path
          d="M152.049 47.0967L152.996 46.9339L152.245 42.6231L152.104 41.7979L151.158 41.9607L152.049 47.0967Z"
          fill="#F08B1F"
        />
        <path
          d="M152.68 45.5114L153.887 45.3051C153.887 45.3051 154.464 45.2182 154.855 44.9576C155.247 44.7187 155.508 44.3278 155.595 43.8826C155.736 43.1334 155.421 42.4385 155.138 42.1453C154.855 41.8521 154.311 41.4178 153.311 41.5915L151.995 41.8196L152.136 42.6448L153.398 42.4276C153.398 42.4276 154.235 42.2213 154.572 43.0357C154.746 43.5243 154.692 44.0455 154.257 44.3278C154.061 44.469 153.431 44.545 152.506 44.7079L152.702 45.5223L152.68 45.5114Z"
          fill="#F08B1F"
        />
        <path
          d="M156.758 46.2821L157.52 40.8638L156.693 41.0049L155.747 46.4558L156.758 46.2821Z"
          fill="#F08B1F"
        />
        <path
          d="M159.303 45.8479L156.747 40.9942L157.574 40.853L160.304 45.6741L159.303 45.8479Z"
          fill="#F08B1F"
        />
        <path
          d="M158.761 43.8947L156.5 44.2859L156.648 45.1418L158.909 44.7506L158.761 43.8947Z"
          fill="#F08B1F"
        />
        <path
          d="M160.793 45.5875L161.75 45.4246L161 41.1138L160.858 40.2886L159.901 40.4515L160.793 45.5875Z"
          fill="#F08B1F"
        />
        <path
          d="M161.424 44.0021L162.631 43.7958C162.631 43.7958 163.207 43.7089 163.599 43.4483C163.99 43.2095 164.251 42.8186 164.338 42.3734C164.48 41.6241 164.164 40.9292 163.882 40.636C163.599 40.3428 163.055 39.9085 162.055 40.0822L160.739 40.3103L160.88 41.1355L162.142 40.9183C162.142 40.9183 162.979 40.712 163.316 41.5264C163.49 42.015 163.436 42.5362 163.001 42.8186C162.805 42.9597 162.174 43.0357 161.25 43.1986L161.446 44.013L161.424 44.0021Z"
          fill="#F08B1F"
        />
        <path
          d="M163.816 45.0663L164.904 44.8708L163.523 43.0249L162.566 43.3289L163.816 45.0663Z"
          fill="#F08B1F"
        />
        <path
          d="M165.514 39.4914L164.496 39.6675L165.388 44.803L166.406 44.6269L165.514 39.4914Z"
          fill="#F08B1F"
        />
        <path
          d="M167.362 39.1591L168.59 38.9419L165.872 43.8499L165.643 42.536L167.362 39.1591Z"
          fill="#F08B1F"
        />
        <path
          d="M168.351 44.2734L169.482 44.0779L166.796 41.2004L166.328 42.0474L168.351 44.2734Z"
          fill="#F08B1F"
        />
        <path
          d="M171.555 38.4544L170.526 38.6323L171.417 43.7678L172.446 43.5899L171.555 38.4544Z"
          fill="white"
        />
        <path
          d="M175.043 37.8484L174.014 38.0264L174.905 43.1619L175.934 42.9839L175.043 37.8484Z"
          fill="white"
        />
        <path
          d="M175.173 40.342L171.305 41.0112L171.452 41.8564L175.32 41.1872L175.173 40.342Z"
          fill="white"
        />
        <path
          d="M176.824 37.5381L175.796 37.7161L176.687 42.8516L177.716 42.6736L176.824 37.5381Z"
          fill="white"
        />
        <path
          d="M178.454 42.5252L179.411 42.3623L178.672 38.0516L178.519 37.2263L177.562 37.3892L178.454 42.5252Z"
          fill="white"
        />
        <path
          d="M179.085 40.9399L180.292 40.7336C180.292 40.7336 180.868 40.6467 181.26 40.3861C181.651 40.1472 181.912 39.7563 181.999 39.3111C182.141 38.5619 181.825 37.8669 181.543 37.5738C181.26 37.2806 180.716 36.8463 179.716 37.02L178.4 37.248L178.541 38.0733L179.803 37.8561C179.803 37.8561 180.64 37.6498 180.977 38.4642C181.151 38.9528 181.097 39.474 180.662 39.7563C180.466 39.8975 179.835 39.9735 178.911 40.1363L179.107 40.9507L179.085 40.9399Z"
          fill="white"
        />
        <path
          d="M181.477 42.004L182.576 41.8194L181.184 39.9626L180.227 40.2667L181.477 42.004Z"
          fill="white"
        />
        <path
          d="M185.947 35.9343L186.099 36.7704L183.337 37.2482L183.565 38.5838L185.979 38.1712L186.132 38.9964L183.707 39.409L183.935 40.7229L186.697 40.2451L186.839 41.0812L183.054 41.7327L182.162 36.6075L185.947 35.9343Z"
          fill="white"
        />
        <path
          d="M189.72 40.4404C189.72 40.4404 188.872 39.7455 189.111 38.7248C189.351 37.7041 190.155 37.4869 190.514 37.4869C190.514 37.4869 191.058 36.716 191.123 35.7605C191.123 35.7605 192.004 36.2491 192.189 38.019C192.189 38.019 192.863 38.019 193.429 37.7475C193.429 37.7475 193.733 39.1808 192.004 40.2015C192.004 40.2015 195.234 39.7346 194.44 36.1188C194.44 36.1188 193.809 36.4988 193.146 36.564C193.146 36.564 192.407 34.338 190.569 33.415C190.569 33.415 190.71 34.5009 190.025 35.9885C190.025 35.9885 188.644 36.2165 188.263 37.6715C187.883 39.1265 188.85 40.1255 189.72 40.4513V40.4404Z"
          fill="#F08B1F"
        />
        <g filter="url(#filter4_d_7224_4716)">
          <path
            d="M22.5159 -44.4727L-16.7129 -37.6859C-21.4473 -36.8669 -24.6202 -32.3708 -23.7999 -27.6437L-17.0028 11.5252C-16.1824 16.2522 -11.6795 19.4203 -6.94517 18.6013L32.2837 11.8145C37.018 10.9955 40.191 6.49941 39.3707 1.77231L32.5735 -37.3966C31.7532 -42.1237 27.2503 -45.2917 22.5159 -44.4727Z"
            fill="#089247"
          />
        </g>
        <g filter="url(#filter5_d_7224_4716)">
          <path
            d="M49.1231 92.2327L9.64777 99.0621C4.91344 99.8812 1.7405 104.377 2.56081 109.104L9.40067 148.519C10.221 153.246 14.7239 156.414 19.4583 155.595L58.9336 148.766C63.6679 147.947 66.8408 143.451 66.0205 138.724L59.1807 99.3089C58.3604 94.5818 53.8574 91.4137 49.1231 92.2327Z"
            fill="#89C81A"
          />
        </g>
        <path
          d="M54.9793 117.035L54.8161 116.08L48.911 117.101L50.4118 125.733L51.3688 125.57L50.7054 121.737L55.2403 120.955L55.0771 120L50.5423 120.782L50.042 117.904L54.9901 117.046L54.9793 117.035Z"
          fill="white"
        />
        <path
          d="M44.2348 118.892L44.0716 117.937L38.1665 118.957L39.6673 127.59L45.5724 126.569L45.4092 125.613L40.4611 126.471L39.9609 123.594L44.4958 122.812L44.3326 121.856L39.7978 122.638L39.2975 119.761L44.2456 118.903L44.2348 118.892Z"
          fill="white"
        />
        <path
          d="M28.0636 121.694L31.0977 121.172C31.8916 121.031 32.6529 121.563 32.7834 122.356C32.9139 123.149 32.3919 123.909 31.598 124.039L28.5639 124.56L28.0636 121.683V121.694ZM34.2297 128.534L35.4804 128.317L31.6415 125.027L31.772 125.005C33.0987 124.756 33.9687 123.485 33.7186 122.161C33.4794 120.868 32.2396 120 30.9346 120.206L26.9326 120.901L28.4334 129.533L29.4012 129.371L28.7379 125.538L30.3909 125.255L34.2297 128.545V128.534Z"
          fill="white"
        />
        <path
          d="M13.3932 123.919L14.0784 123.116L18.3957 126.819L15.5682 131.748L14.6547 131.227L17.0472 127.058L13.3932 123.93V123.919Z"
          fill="black"
        />
        <path
          d="M22.2237 122.399L21.3102 121.878L18.4827 126.808L22.8001 130.511L23.4852 129.707L19.8312 126.58L22.2237 122.41V122.399Z"
          fill="black"
        />
        <g filter="url(#filter6_d_7224_4716)">
          <path
            d="M199.986 78.1895L160.51 85.0189C155.776 85.838 152.603 90.334 153.423 95.0611L160.263 134.476C161.084 139.203 165.587 142.371 170.321 141.552L209.796 134.723C214.531 133.904 217.703 129.408 216.883 124.681L210.043 85.2656C209.223 80.5385 204.72 77.3705 199.986 78.1895Z"
            fill="white"
          />
        </g>
        <path
          d="M162.359 108.794L163.088 107.491C163.686 107.849 164.436 107.98 165.056 107.871C165.719 107.752 165.98 107.458 165.915 107.057C165.839 106.633 165.426 106.557 164.73 106.416L163.718 106.177C162.881 106.003 162.065 105.482 161.88 104.429C161.663 103.202 162.598 102.018 164.164 101.747C165.045 101.595 165.969 101.769 166.709 102.246L165.991 103.549C165.437 103.289 164.893 103.18 164.425 103.267C163.881 103.365 163.566 103.636 163.642 104.016C163.718 104.44 164.208 104.516 164.904 104.657L165.882 104.874C166.861 105.08 167.514 105.591 167.688 106.622C167.905 107.849 167.057 109.098 165.284 109.402C164.295 109.576 163.251 109.402 162.359 108.805V108.794Z"
          fill="#084D6D"
        />
        <path
          d="M168.351 105.83C168.025 103.973 169.232 102.659 170.787 102.387C171.472 102.268 172.049 102.409 172.527 102.702L171.896 103.918C171.603 103.777 171.374 103.734 171.124 103.777C170.341 103.908 169.961 104.603 170.124 105.526C170.287 106.448 170.907 106.97 171.603 106.85C171.972 106.785 172.266 106.6 172.516 106.329L173.386 107.306C172.929 107.893 172.244 108.186 171.646 108.294C170.069 108.566 168.667 107.697 168.351 105.83Z"
          fill="#084D6D"
        />
        <path
          d="M173.332 104.961C173.006 103.104 174.148 101.801 175.572 101.551C176.997 101.302 178.519 102.149 178.835 104.005C179.15 105.862 178.019 107.176 176.594 107.426C175.17 107.675 173.658 106.818 173.343 104.961H173.332ZM177.04 104.32C176.877 103.397 176.475 102.843 175.811 102.952C175.148 103.061 174.952 103.723 175.115 104.657C175.279 105.591 175.692 106.134 176.344 106.025C176.997 105.916 177.203 105.265 177.04 104.32Z"
          fill="#084D6D"
        />
        <path
          d="M180.009 104.505L179.411 101.03L181.162 100.726L181.727 103.973C181.858 104.755 182.108 104.939 182.554 104.863C182.945 104.798 183.163 104.592 183.391 104.125L182.75 100.444L184.501 100.14L185.468 105.743L184.044 105.993L183.783 105.243H183.739C183.37 105.884 182.902 106.329 182.141 106.459C180.912 106.677 180.238 105.895 179.998 104.494L180.009 104.505Z"
          fill="#084D6D"
        />
        <path
          d="M186.763 103.397L186.382 101.237L185.621 101.367L185.392 100.064L186.241 99.8576L186.143 98.1094L187.589 97.8596L187.883 99.5752L189.209 99.3472L189.449 100.715L188.122 100.943L188.492 103.082C188.6 103.712 188.938 103.897 189.351 103.832C189.536 103.799 189.721 103.745 189.862 103.658L190.34 104.831C190.069 104.994 189.655 105.178 189.101 105.276C187.698 105.515 186.969 104.722 186.741 103.408L186.763 103.397Z"
          fill="#084D6D"
        />
        <path
          d="M163.827 114.527L165.589 114.223L166.611 120.098L169.471 119.598L169.721 121.064L165.1 121.867L163.827 114.527Z"
          fill="#084D6D"
        />
        <path
          d="M169.906 118.154C169.591 116.341 170.711 114.994 172.049 114.766C173.68 114.484 174.669 115.515 174.93 117.046C174.985 117.361 175.007 117.665 174.996 117.828L171.69 118.404C171.983 119.131 172.571 119.37 173.277 119.24C173.68 119.175 174.071 118.979 174.43 118.686L175.181 119.641C174.669 120.163 173.93 120.51 173.267 120.619C171.668 120.901 170.232 120.043 169.906 118.165V118.154ZM173.375 116.894C173.277 116.34 172.962 115.971 172.331 116.08C171.831 116.167 171.472 116.558 171.472 117.231L173.386 116.905L173.375 116.894Z"
          fill="#084D6D"
        />
        <path
          d="M175.942 118.382C175.735 117.198 176.54 116.395 178.715 115.787C178.585 115.331 178.302 115.103 177.725 115.2C177.269 115.276 176.844 115.515 176.344 115.928L175.539 114.907C176.192 114.332 176.953 113.908 177.834 113.756C179.28 113.506 180.237 114.169 180.542 115.928L181.097 119.109L179.672 119.359L179.454 118.816H179.411C179.02 119.316 178.563 119.696 177.932 119.804C176.91 119.978 176.127 119.326 175.964 118.393L175.942 118.382ZM179.052 117.752L178.9 116.862C177.812 117.198 177.519 117.567 177.595 117.958C177.649 118.284 177.888 118.404 178.28 118.338C178.628 118.273 178.835 118.067 179.063 117.752H179.052Z"
          fill="#084D6D"
        />
        <path
          d="M181.477 113.268L182.902 113.018L183.195 113.963H183.239C183.511 113.126 184.076 112.67 184.642 112.573C184.968 112.518 185.164 112.518 185.338 112.573L185.262 114.104C185.055 114.104 184.925 114.093 184.674 114.136C184.261 114.212 183.794 114.571 183.63 115.363L184.185 118.567L182.445 118.871L181.477 113.268Z"
          fill="#084D6D"
        />
        <path
          d="M186.056 112.475L187.48 112.225L187.73 112.898H187.774C188.155 112.356 188.655 111.878 189.427 111.747C190.645 111.541 191.319 112.312 191.558 113.713L192.157 117.187L190.406 117.492L189.84 114.245C189.71 113.463 189.46 113.268 189.014 113.344C188.622 113.409 188.416 113.648 188.122 114.017L188.774 117.774L187.034 118.078L186.067 112.475H186.056Z"
          fill="#084D6D"
        />
        <path
          d="M192.146 109.673C192.048 109.13 192.396 108.707 192.972 108.609C193.549 108.511 194.016 108.794 194.114 109.326C194.212 109.858 193.864 110.303 193.288 110.401C192.711 110.499 192.243 110.216 192.146 109.673ZM192.548 111.346L194.288 111.041L195.256 116.644L193.516 116.948L192.548 111.346Z"
          fill="#084D6D"
        />
        <path
          d="M195.724 110.803L197.148 110.553L197.398 111.226H197.442C197.822 110.683 198.323 110.205 199.095 110.075C200.313 109.869 200.987 110.64 201.226 112.04L201.824 115.515L200.074 115.819L199.508 112.573C199.378 111.791 199.127 111.595 198.682 111.671C198.29 111.736 198.083 111.975 197.79 112.344L198.442 116.101L196.702 116.406L195.734 110.803H195.724Z"
          fill="#084D6D"
        />
        <path
          d="M203.021 116.286C202.945 115.819 203.151 115.407 203.619 115.048V115.005C203.282 114.853 203.021 114.592 202.934 114.136C202.868 113.745 203.053 113.289 203.369 112.964V112.92C202.923 112.714 202.466 112.258 202.357 111.606C202.118 110.238 203.129 109.38 204.358 109.174C204.674 109.12 204.989 109.109 205.261 109.152L207.327 108.794L207.545 110.054L206.664 110.206C206.783 110.347 206.903 110.596 206.957 110.868C207.186 112.171 206.294 112.92 205.043 113.137C204.848 113.17 204.619 113.181 204.358 113.148C204.249 113.278 204.217 113.387 204.239 113.561C204.282 113.832 204.532 113.919 205.13 113.811L206.022 113.658C207.414 113.42 208.262 113.702 208.436 114.712C208.643 115.895 207.556 116.949 205.598 117.285C204.304 117.513 203.173 117.285 202.999 116.286H203.021ZM206.827 115.309C206.773 114.972 206.468 114.951 205.935 115.048L205.391 115.146C204.989 115.211 204.772 115.233 204.587 115.211C204.434 115.396 204.369 115.57 204.402 115.754C204.467 116.156 204.978 116.286 205.707 116.156C206.435 116.026 206.892 115.667 206.827 115.309ZM205.413 111.074C205.315 110.499 204.967 110.26 204.554 110.325C204.141 110.39 203.891 110.738 203.989 111.313C204.086 111.889 204.445 112.149 204.859 112.084C205.272 112.019 205.522 111.661 205.413 111.074Z"
          fill="#084D6D"
        />
        <g filter="url(#filter7_d_7224_4716)">
          <path
            d="M35.8531 23.1502L-3.62225 29.9796C-8.35658 30.7987 -11.5295 35.2947 -10.7092 40.0218L-3.86935 79.4368C-3.04903 84.1639 1.4539 87.3319 6.18823 86.5129L45.6635 79.6835C50.3979 78.8644 53.5708 74.3684 52.7505 69.6413L45.9106 30.2263C45.0903 25.4992 40.5874 22.3311 35.8531 23.1502Z"
            fill="white"
          />
        </g>
        <path
          d="M9.65223 59.1059C8.52123 59.3013 7.83611 58.4761 7.68386 57.6183C7.53161 56.7605 7.93398 55.7506 9.06498 55.5552C9.94586 55.4032 10.8267 55.9895 11.0116 57.0645C11.1639 58.096 10.5114 58.943 9.65223 59.095V59.1059ZM10.6419 55.4575C10.2504 55.1534 9.69573 54.7951 8.86923 54.9363C7.50986 55.1751 6.66161 56.3696 6.91173 57.7812C7.17273 59.2796 8.44511 60.018 9.68486 59.8117C10.457 59.6814 10.9572 59.2253 11.2074 58.7476H11.24L11.3487 59.3556L12.0991 59.2253L11.3161 54.6865L10.5657 54.8168L10.6745 55.4575H10.6419Z"
          fill="#73C41D"
        />
        <path
          d="M17.1233 53.5139C16.3186 53.6551 15.851 54.2197 15.7096 54.7301C15.4268 54.2414 14.7743 53.9265 14.0457 54.046C13.4693 54.1437 13.0452 54.5346 12.8168 55.0015H12.7842L12.6863 54.426L11.936 54.5563L12.719 59.0951L13.4693 58.9648L13.0343 56.4457C12.8712 55.501 13.2736 54.8712 14.024 54.7409C14.6873 54.6215 15.2093 55.1318 15.3398 55.881L15.8075 58.5956L16.5796 58.4653L16.1337 55.9245C15.9488 54.8712 16.4817 54.3283 17.1233 54.2197C17.8955 54.0894 18.3413 54.6323 18.461 55.3598L18.9286 58.0744L19.679 57.9441L19.2222 55.2947C18.983 53.9374 18.1456 53.3728 17.1233 53.5465"
          fill="#73C41D"
        />
        <path
          d="M27.9657 55.9352C27.0849 56.0873 26.1822 55.5009 25.9974 54.4476C25.8234 53.4487 26.3889 52.5909 27.3567 52.4171C28.3246 52.2434 29.1511 52.9058 29.3251 53.8722C29.4991 54.8385 28.9445 55.7615 27.9657 55.9244M27.2371 51.7439C25.856 51.9828 24.9751 53.1881 25.2252 54.5997C25.4754 56.0113 26.7042 56.8473 28.0854 56.6085C29.4665 56.3696 30.3256 55.0774 30.0972 53.7527C29.8471 52.3411 28.6509 51.4942 27.2371 51.7439Z"
          fill="#73C41D"
        />
        <path
          d="M33.338 55.0017C32.4571 55.1537 31.5545 54.5673 31.3696 53.5141C31.1956 52.5151 31.7611 51.6573 32.729 51.4835C33.6969 51.3098 34.5234 51.9722 34.6974 52.9386C34.8387 53.9375 34.2841 54.8279 33.338 54.9908M32.6094 50.8103C31.2282 51.0492 30.3474 52.2545 30.5975 53.6661C30.8476 55.0777 32.0765 55.9137 33.4576 55.6749C34.8387 55.436 35.6979 54.1438 35.4695 52.8191C35.2194 51.4075 34.0231 50.5606 32.6094 50.8103Z"
          fill="#73C41D"
        />
        <path
          d="M38.9821 51.8853L36.5461 52.3087L36.209 50.3759L35.6544 50.4737L36.4482 55.0125L37.0029 54.9147L36.6331 52.8082L39.0691 52.3847L39.4389 54.4913L39.9935 54.3935L39.1996 49.8547L38.645 49.9525L38.9821 51.8853Z"
          fill="#73C41D"
        />
        <path
          d="M40.9614 51.744L40.6786 50.1152L41.5051 49.9741C42.0815 49.8763 42.473 50.1152 42.56 50.6473C42.6361 51.0925 42.3969 51.5051 41.7879 51.6028L40.9614 51.744ZM42.2881 51.972C42.8536 51.7657 43.2342 51.1793 43.1255 50.5496C43.0167 49.9198 42.4839 49.29 41.342 49.4854L40.037 49.7135L40.82 54.2523L41.3746 54.1545L41.0484 52.276L41.6574 52.1675L43.3647 53.8071L44.0607 53.6876L42.2772 51.972H42.2881Z"
          fill="#73C41D"
        />
        <path
          d="M43.4409 49.1271L44.1586 48.9968L44.1804 49.1163L43.8759 49.1597L44.0281 50.0501L43.8867 50.0718L43.7345 49.1923L43.4626 49.2357L43.4409 49.1271Z"
          fill="#73C41D"
        />
        <path
          d="M44.9198 49.5832L45.1047 48.834L45.2678 48.8123L45.4962 49.8004L45.3548 49.8221L45.1917 49.0186L45.0068 49.7352L44.8872 49.7569L44.474 49.1489L44.5827 49.9524L44.4413 49.9741L44.3217 48.9751L44.4957 48.9426L44.9198 49.5832Z"
          fill="#73C41D"
        />
        <path
          d="M4.12773 60.1159C3.18161 60.2788 2.25723 59.6707 2.08323 58.6717C1.90923 57.6728 2.46385 56.7281 3.54048 56.5435C4.6171 56.3589 5.4436 57.1298 5.59585 58.0419C5.76985 59.0409 5.21523 59.9313 4.12773 60.1159ZM3.46435 55.816C2.58348 55.968 2.15935 56.3589 1.88748 56.7498L1.82223 56.8475L1.31111 53.9158L0.56073 54.0461L1.38723 58.8346C1.63736 60.3005 2.94235 61.0389 4.24735 60.8217C5.68285 60.572 6.5746 59.2798 6.33535 57.8682C6.12873 56.5326 4.76935 55.5988 3.47523 55.8268"
          fill="#73C41D"
        />
        <path
          d="M22.5935 56.9234C21.6473 57.0863 20.723 56.4782 20.549 55.4792C20.375 54.4803 20.9296 53.5356 22.0062 53.351C23.0828 53.1664 23.9093 53.9373 24.0616 54.8495C24.203 55.8484 23.681 56.7388 22.5935 56.9234ZM21.9301 52.6235C21.0492 52.7755 20.6251 53.1664 20.3532 53.5573L20.288 53.655L19.853 51.1685L19.1026 51.2988L19.853 55.6421C20.1031 57.108 21.4081 57.8464 22.7131 57.6292C24.1486 57.3794 25.0403 56.0873 24.8011 54.6757C24.5727 53.351 23.2351 52.4063 21.941 52.6343"
          fill="#73C41D"
        />
        <path
          d="M0.756475 57.2818C0.756475 57.2818 0.41935 57.2818 0.125726 57.2818C-0.18965 57.2818 -0.331024 57.2818 -0.7769 57.1841C-1.19015 57.0863 -1.6469 56.7606 -2.06015 56.3805C-2.49515 56.0005 -3.45215 55.4576 -3.45215 55.4576C-3.45215 55.4576 -3.20202 55.4467 -2.9084 55.4576C-2.68002 55.4793 -2.09277 55.5444 -1.48377 55.7507C-1.33152 55.7833 -1.26627 55.8268 -1.11402 55.8919C-0.896524 55.9679 -0.668148 56.1308 -0.450648 56.2937C-0.189648 56.4783 0.0387259 56.6411 0.234476 56.804C-0.0156491 56.5108 -0.700773 55.3707 -1.78827 54.5346C-1.88615 54.4369 -1.09227 54.7844 -0.863899 54.9472C-0.200524 55.4576 -0.0591495 55.7725 0.223601 56.2937L0.745602 57.3144L0.756475 57.2818Z"
          fill="#73C41D"
        />
        <g filter="url(#filter8_d_7224_4716)">
          <path
            d="M101.266 -26.4384L61.7908 -19.609C57.0564 -18.79 53.8835 -14.2939 54.7038 -9.56681L61.5437 29.8481C62.364 34.5752 66.8669 37.7433 71.6013 36.9243L111.077 30.0949C115.811 29.2758 118.984 24.7798 118.164 20.0527L111.324 -19.3623C110.503 -24.0894 106 -27.2575 101.266 -26.4384Z"
            fill="white"
          />
        </g>
        <path
          d="M64.7015 12.1978C64.1251 12.0132 63.6357 11.644 63.2334 11.1662C62.8636 10.6885 62.6026 10.1238 62.4939 9.49406C62.3851 8.86427 62.4395 8.2562 62.6352 7.70242C62.8201 7.12693 63.1899 6.6383 63.6684 6.23655C64.1795 5.82393 64.7776 5.56333 65.3975 5.45474C66.137 5.29187 66.8982 5.42217 67.5942 5.71535L67.094 6.89891C66.6372 6.66002 66.137 6.55144 65.6041 6.63831C65.2017 6.70346 64.8102 6.87719 64.5057 7.14865C64.223 7.38754 63.9946 7.74586 63.9076 8.11505C63.7771 8.49509 63.7554 8.90771 63.8532 9.30947C63.9185 9.71123 64.0816 10.0695 64.2991 10.3844C64.7994 11.0359 65.5932 11.3508 66.398 11.2097C66.8982 11.1228 67.3659 10.8514 67.7139 10.4713L68.573 11.3508C68.0292 11.8938 67.3441 12.2412 66.5937 12.3715C65.963 12.4475 65.3105 12.4041 64.7015 12.1869V12.1978Z"
          fill="#3067DB"
        />
        <path
          d="M70.7263 5.82399L71.0199 7.53961L73.4233 7.12699L73.5973 8.12596L71.1939 8.53858L71.4875 10.2542L74.3911 9.75471L74.576 10.8188L70.3674 11.5463L69.2364 4.99875L73.4233 4.27124L73.6081 5.33536L70.7371 5.83484L70.7263 5.82399Z"
          fill="#3067DB"
        />
        <path
          d="M77.7406 7.52882L77.3382 7.59397L77.795 10.2434L76.5117 10.4606L75.3807 3.91299L77.7189 3.51122C78.0886 3.44607 78.5127 3.43522 78.8825 3.53294C79.2522 3.63067 79.5676 3.79355 79.8395 4.07586C80.1114 4.35818 80.3071 4.70565 80.3397 5.08569C80.4485 5.52003 80.3615 5.97607 80.1114 6.34526C79.8612 6.71444 79.4915 7.02934 79.0674 7.20307L81.6991 9.5702L80.144 9.84165L77.7515 7.52882H77.7406ZM77.1642 6.63844L77.9472 6.50814C78.3496 6.44299 78.6215 6.29097 78.8064 6.10637C78.9912 5.92178 79.0782 5.6069 79.0021 5.36801C78.9586 5.08569 78.8064 4.82509 78.5671 4.70565C78.317 4.55363 77.9907 4.54277 77.5884 4.61878L76.8706 4.73822L77.1642 6.64929V6.63844Z"
          fill="#3067DB"
        />
        <path
          d="M84.3526 9.114L83.0694 9.33117L81.9384 2.78357L83.2216 2.56641L84.3526 9.114Z"
          fill="#3067DB"
        />
        <path
          d="M89.5618 1.91498C90.1055 2.07786 90.6167 2.4036 90.9755 2.85965C91.3344 3.3157 91.6063 3.86948 91.6715 4.47755C91.7694 5.07476 91.7477 5.68283 91.5628 6.22575C91.3779 6.76866 90.9973 7.2573 90.5514 7.61562C90.0077 7.99567 89.3769 8.26712 88.7244 8.38657L86.6038 8.75575L85.4728 2.20815L87.5934 1.83897C88.2459 1.69781 88.9201 1.70867 89.5726 1.91498H89.5618ZM90.0185 6.4212C90.3557 5.976 90.4753 5.3788 90.3557 4.66215C90.236 3.94549 89.9315 3.48944 89.453 3.15283C88.9854 2.8488 88.3547 2.72935 87.6043 2.85965L86.9192 2.9791L87.6913 7.40931L88.3764 7.28987C89.1594 7.18129 89.6923 6.89896 90.0294 6.4212H90.0185Z"
          fill="#3067DB"
        />
        <path
          d="M95.2711 7.22485L93.9879 7.44201L92.8569 0.894418L94.1401 0.677246L95.2711 7.22485Z"
          fill="#3067DB"
        />
        <path
          d="M101.035 4.68396L98.3814 5.14001L98.1095 6.72534L96.7067 6.96422L98.1639 -0.028567L99.4798 -0.256592L103.21 5.83495L101.807 6.07383L101.046 4.66225L101.035 4.68396ZM100.491 3.75014L99.0557 1.20929L98.5554 4.08676L100.491 3.75014Z"
          fill="#3067DB"
        />
        <path
          d="M109.311 -1.95068L110.442 4.59691L109.256 4.80322L105.254 0.839917L106.037 5.357L104.787 5.57417L103.656 -0.973429L104.841 -1.17974L108.811 2.78357L108.028 -1.73352L109.311 -1.95068Z"
          fill="#3067DB"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_7224_4716"
          x="76.2388"
          y="104.234"
          width="75.0391"
          height="74.9429"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7224_4716" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7224_4716"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_7224_4716"
          x="63.173"
          y="34.9885"
          width="75.718"
          height="75.6206"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7224_4716" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7224_4716"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_7224_4716"
          x="119.26"
          y="-65.9004"
          width="76.0826"
          height="75.9846"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7224_4716" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7224_4716"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_7224_4716"
          x="132.953"
          y="3.59277"
          width="75.2654"
          height="75.1687"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7224_4716" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7224_4716"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_7224_4716"
          x="-29.9291"
          y="-50.6016"
          width="75.4289"
          height="75.3318"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7224_4716" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7224_4716"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_7224_4716"
          x="-3.56836"
          y="86.1038"
          width="75.718"
          height="75.6206"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7224_4716" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7224_4716"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_7224_4716"
          x="147.294"
          y="72.0605"
          width="75.718"
          height="75.6206"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7224_4716" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7224_4716"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_7224_4716"
          x="-16.8384"
          y="17.0212"
          width="75.718"
          height="75.6206"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7224_4716" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7224_4716"
            result="shape"
          />
        </filter>
        <filter
          id="filter8_d_7224_4716"
          x="48.5746"
          y="-32.5674"
          width="75.718"
          height="75.6206"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7224_4716" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7224_4716"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_7224_4716">
          <rect width="203" height="131" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
